import React, { useEffect, useState } from 'react';
import { Form } from 'antd';
import { useAuth } from '../../../../contexts/userContext/userContext';
import { ReactComponent as Edit } from '../../../../../resources/images/svg/editNote.svg';
import { ReactComponent as Delete } from '../../../../../resources/images/svg/delete.svg';
import WhiteHoverButton from '../../../components/buttons/WhiteHoverButton';
import ProfileForm from '../../../forms/profile/ProfileForm';
import { ReactComponent as OpenLock } from '../../../../../resources/images/svg/openLock.svg';
import useTranslation from '../../../../hooks/translation/useTranslation';
import { useModal } from '../../../../contexts/modalsContext/modalsContext';
import ChangePasswordModal from '../../../components/modals/changePasswordModal/ChangePasswordModal';
import EditProfile from '../../../components/globalActions/EditProfile';
import { getLoginFormOptions } from '../../../../../services/login/Login.api';
import ChangePasswordDrawer from '../../../components/drawers/changePasswordDrawer/ChangePasswordDrawer';
import AccountDeactivateModal from '../../../components/modals/accountDeactivateModal/AccountDeactivateModal';

function ProfileData() {
  const { user } = useAuth();
  const [form] = Form.useForm();
  const { trans } = useTranslation();
  const { setShowChangePasswordModal, setShowEditProfile, setShowDeactivateModal } = useModal();
  const [formOptions, setFormOptions] = useState();

  useEffect(() => {
    const fetchFormOptions = async () => {
      const res = await getLoginFormOptions();
      if (res.status === 'success') {
        setFormOptions(res.data);
        const userCountry = res.data.countries.find(
          (country) => country.id === (user?.country || user?.citizenship),
        );
        form.setFieldsValue({
          ...user,
          country_ka: userCountry?.name_ka,
          country_en: userCountry?.name_en || userCountry?.name_ka,
          country_ru: userCountry?.name_ru || userCountry?.name_ka,
          id_number: user?.personal_number || user?.passport_number || user?.identification_number,
        });
      }
    };
    if (user?.id) {
      fetchFormOptions();
    }
  }, [user]);

  const showModal = () => {
    setShowChangePasswordModal(true);
  };

  const showEditProfileModal = () => {
    setShowEditProfile(true);
  };

  const handleProfileDeactivate = async () => {
    setShowDeactivateModal(true);
  };

  return (
    <div className="flex flex-col gap-5 lg:gap-10">
      <div className="flex gap-3 lg:gap-[34px] lg:items-center flex-col lg:flex-row">
        <h3 className="m-0 text-2xl flex items-center">
          {(user?.name ?? '').toUpperCase()}
        </h3>
        <WhiteHoverButton onClick={showEditProfileModal}>
          <div className="flex items-center gap-2 text-base">
            <Edit />
            {/* მონაცემების რედაქტირება */}
            {trans('edit_profile')}
          </div>
        </WhiteHoverButton>
        <WhiteHoverButton onClick={handleProfileDeactivate}>
          <div className="flex items-center gap-2 text-base">
            <Delete />
            {trans('deactivate_account')}
          </div>
        </WhiteHoverButton>
      </div>
      <ProfileForm form={form} />
      <div>
        <WhiteHoverButton onClick={showModal}>
          <div className="flex gap-[10px]">
            <OpenLock />
            <h3 className="m-0 text-base">{trans('change_password')}</h3>
          </div>
        </WhiteHoverButton>
        <div className="flex-1" />
      </div>
      <EditProfile formOptions={formOptions} />
      <ChangePasswordModal />
      <ChangePasswordDrawer />
      <AccountDeactivateModal />
    </div>
  );
}

export default ProfileData;
